import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, MapPin, Users, Kanban, Settings as SettingsIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/lead-finder", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/lead-finder/scanner", label: "Map Scanner", icon: MapPin },
  { to: "/lead-finder/leads", label: "Leads Repository", icon: Users },
  // { to: "/lead-finder/crm", label: "CRM Pipeline", icon: Kanban },
  { to: "/lead-finder/settings", label: "Settings", icon: SettingsIcon },
];

export default function LeadFinderLayout() {
  return (
    <div className="-mx-6 lg:-mx-10 -my-8 lg:-my-10 h-[calc(100vh-0px)] flex flex-col">
      <div className="sticky top-0 z-20 border-b border-white/[0.06] bg-[#09090b]/90 backdrop-blur-xl px-6 lg:px-10 shrink-0">
        <nav className="flex gap-1 overflow-x-auto py-3 no-scrollbar">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "flex shrink-0 items-center gap-2 rounded-lg px-3.5 py-2 text-[13px] font-medium transition-all whitespace-nowrap",
                  isActive
                    ? "bg-white/[0.08] text-white border border-indigo-400/40"
                    : "text-white/60 hover:text-white hover:bg-white/[0.04] border border-transparent"
                )
              }
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="text-[#ededed] flex-1 min-h-0 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
